import React from 'react';
import { Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

/**
 * Reusable BackButton component that provides consistent back navigation
 */
function BackButton(props) {
  const { to, label = "Back" } = props;
  
  const navigate = useNavigate();

  return (
    <Button
      startIcon={<ArrowBack />}
      onClick={() => navigate(to || -1)}
    >
      {label}
    </Button>
  );
}

export default BackButton;
